import React from "react";
import {Box, Columns, Table} from "react-bulma-components";
import Collapsible from "react-collapsible";
import {formatDateTime} from "../../utils";



export default function PrintLog({rental}){



    return (
        <Box>
            <Collapsible
                trigger={"Print Log"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"}>
                            <thead>
                                <tr>
                                    <th>Date/Time</th>
                                    <th>User</th>
                                </tr>
                            </thead>
                            <tbody>
                            {rental.rental_print_log && rental.rental_print_log.map(log => (
                                <tr>
                                    <td>{formatDateTime(new Date(log.timestamp))}</td>
                                    <td>{log.user ? log.user.first_name + " " +log.user.last_name : ""}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )

}